import { render, staticRenderFns } from "./StocktakingRegist.vue?vue&type=template&id=873db652&"
import script from "./StocktakingRegist.vue?vue&type=script&lang=js&"
export * from "./StocktakingRegist.vue?vue&type=script&lang=js&"
import style0 from "./StocktakingRegist.vue?vue&type=style&index=0&id=873db652&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports